export default __webpack_public_path__ + "static/media/Autokritigallery_1.87becbd3.jpg";